import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['toggle', 'disable']

  connect() {
    this._observers = []
  }

  disconnect() {
    this._observers.forEach(observer => observer.disconnect())
    this._observers = []
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const { toggleUrl } = this.element.dataset

    if (toggleUrl) {
      this.loadAndShow()
    } else {
      this.toggleVisibility()
    }

    this.toggleDisable()
  }

  toggleVisibility() {
    const targets = this.resolveToggleTargets()
    targets.forEach(el => el.classList.toggle('hidden'))
    this.toggleButtonVisibility()
  }

  loadAndShow() {
    this.toggleIconLoading(true)

    const targets = this.resolveToggleTargets()
    const { toggleUrl } = this.element.dataset

    targets.forEach((element) => {
      const shouldLoad = element.classList.contains('hidden') && !element.dataset.loaded

      if (!toggleUrl) return

      if (shouldLoad) {
        element.innerHTML = '<div class="text-sm text-gray-500">Loading...</div>'

        $.ajax({
          url: toggleUrl,
          method: 'POST',
          dataType: 'html',
          headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
          success: (html) => {
            element.innerHTML = html
            element.dataset.loaded = 'true'
            element.classList.remove('hidden')
            this._attachObserverFor(element)
            this.toggleButtonVisibility()
          },
          error: () => {
            element.innerHTML = '<div class="text-sm text-red-500">Failed to load</div>'
            this.toggleButtonVisibility()
          },
          complete: () => this.toggleIconLoading(false)
        })
        return
      }

      element.classList.toggle('hidden')
      this.toggleIconLoading(false)
      this.toggleButtonVisibility()
    })
  }

  toggleDisable() {
    this.disableTargets.forEach((element) => {
      element.disabled = !element.disabled
    })
  }

  resolveToggleTargets() {
    const selector = this.element.dataset.toggleToggleTargetSelector
    const container = this.element.closest('.toggle-container')

    if (selector && container) {
      return Array.from(container.querySelectorAll(selector))
    }

    if (this.hasToggleTarget) {
      return this.toggleTargets
    }

    return []
  }

  toggleIconLoading(isLoading) {
    const icon = this.element.querySelector('.icon-eye')
    const spinner = this.element.querySelector('.spinner-eye')

    if (!icon || !spinner) return

    icon.classList.toggle('hidden', isLoading)
    spinner.classList.toggle('hidden', !isLoading)
  }

  toggleButtonVisibility() {
    const targets = this.resolveToggleTargets()
    const button = this.element

    if (!button || targets.length === 0) return

    const hasContent = targets.some(target => target.querySelector('[data-toggle-item], [name="attachment"], [data-item]'))

    button.classList.toggle('hidden', !hasContent)
  }

  _attachObserverFor(element) {
    const observer = new MutationObserver(() => this.toggleButtonVisibility())
    observer.observe(element, { childList: true, subtree: true })
    this._observers.push(observer)
  }
}
